/*
 * Tykables — Filter UX enhancements on top of Dawn
 * Edit log:
 *   - 2026-07-21  FIX-20260721-03  John-Michael  Reorder the Size facet
 *       Small→Medium→Large→XL→XXL (was alphabetical). See the block at EOF.
 * -----------------------------------------------------------------------------
 * Non-invasive additions layered over Dawn's facet drawer. We do NOT touch
 * the drawer internals — Dawn's menu-drawer component uses a submenu slide
 * pattern that breaks if we pre-open details.
 *
 * What this does:
 *   1. Active-filter chip row above the product grid. Mirrors Dawn's
 *      active-facets block with one-tap removal chips.
 *   2. Quick-filter deep-linking: <button data-quick-filter="{param_name}">
 *      elements (rendered via Liquid) open Dawn's drawer AND click the
 *      matching summary so customers jump straight into that filter's
 *      submenu with a single tap.
 *
 * Earlier versions of this file also auto-expanded every filter category
 * on drawer open and injected a "Done — N products" button. Both removed:
 *   - Auto-expand conflicted with Dawn's submenu slide pattern (tapping a
 *     category showed a blank drawer)
 *   - Done button duplicated Dawn's native "Apply" button (double CTA)
 */
(function () {
  'use strict';

  function renderActiveChipsRow() {
    var host = document.querySelector('[data-tyk-active-chips]');
    if (!host) return;

    var links = document.querySelectorAll(
      '#FacetFiltersFormMobile .active-facets__button-wrapper a, ' +
      '#FacetFiltersFormMobile .active-facets__button'
    );

    host.innerHTML = '';
    if (!links.length) {
      host.hidden = true;
      return;
    }
    host.hidden = false;

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href') || '';
      var label = (link.getAttribute('aria-label') || link.textContent || '').trim();
      label = label.replace(/Remove filter\s*\|?\s*/i, '').replace(/^filter:/i, '').trim();
      if (!label) continue;

      var chip = document.createElement('a');
      chip.href = href;
      chip.className = 'tyk-active-chip';
      chip.setAttribute('role', 'button');
      chip.setAttribute('aria-label', 'Remove filter: ' + label);
      chip.innerHTML =
        '<span class="tyk-active-chip__label"></span>' +
        '<span class="tyk-active-chip__x" aria-hidden="true">\u00d7</span>';
      chip.querySelector('.tyk-active-chip__label').textContent = label;
      host.appendChild(chip);
    }

    if (links.length >= 2) {
      var clearHref = getClearAllHref();
      if (clearHref) {
        var clear = document.createElement('a');
        clear.href = clearHref;
        clear.className = 'tyk-active-chip tyk-active-chip--clear';
        clear.setAttribute('role', 'button');
        clear.setAttribute('aria-label', 'Clear all filters');
        clear.textContent = 'Clear all';
        host.appendChild(clear);
      }
    }
  }

  function getClearAllHref() {
    var dawnClear = document.querySelector(
      '#FacetFiltersFormMobile .active-facets__button-remove[href], ' +
      '#FacetFiltersFormMobile .active-facets__button--light[href]'
    );
    if (dawnClear) return dawnClear.getAttribute('href');
    return window.location.pathname;
  }

  function ensureChipHost() {
    if (document.querySelector('[data-tyk-active-chips]')) return;
    var main = document.querySelector('.tyk-collection__main');
    if (!main) return;
    var host = document.createElement('div');
    host.setAttribute('data-tyk-active-chips', '');
    host.className = 'tyk-active-chips';
    host.hidden = true;
    main.insertBefore(host, main.firstChild);
  }

  function boot() {
    ensureChipHost();
    renderActiveChipsRow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Dawn re-renders the facets + product grid via AJAX on every filter change.
  // Watch for those changes so our chip row stays current.
  if (window.MutationObserver) {
    var targets = [
      document.getElementById('ProductGridContainer'),
      document.getElementById('FacetsWrapperMobile')
    ].filter(Boolean);
    var obs = new MutationObserver(function () {
      if (window.__tykFacetsDebounce) clearTimeout(window.__tykFacetsDebounce);
      window.__tykFacetsDebounce = setTimeout(boot, 120);
    });
    for (var i = 0; i < targets.length; i++) {
      obs.observe(targets[i], { childList: true, subtree: true });
    }
  }

  // ───────────────────────────────────────────────────────────────────────────
  // Quick-filter chips: inline popover dropdown.
  //    Tapping a chip toggles an attached popover listing that filter's values.
  //    Each value is an <a href="{value.url_to_add or url_to_remove}"> — Dawn's
  //    FacetFiltersForm intercepts these URLs and does AJAX refresh, so tap
  //    → apply → grid updates, no manual Apply button needed.
  //    Closing: tap the chip again, tap outside, or press Escape.
  // ───────────────────────────────────────────────────────────────────────────
  function closeAllPopovers(except) {
    var open = document.querySelectorAll('.tyk-quick-filter[aria-expanded="true"]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].setAttribute('aria-expanded', 'false');
      var popId = open[i].getAttribute('data-quick-filter-toggle');
      var pop = popId && document.getElementById(popId);
      if (pop) pop.hidden = true;
    }
  }

  function togglePopover(toggleBtn) {
    var popId = toggleBtn.getAttribute('data-quick-filter-toggle');
    if (!popId) return;
    var pop = document.getElementById(popId);
    if (!pop) return;

    var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
    closeAllPopovers(isOpen ? null : toggleBtn);

    toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    pop.hidden = isOpen;
  }

  // Delegated click: toggle popovers + close when clicking outside.
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target && e.target.closest && e.target.closest('[data-quick-filter-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      togglePopover(toggleBtn);
      return;
    }
    // Click outside any popover? Close them all.
    if (!e.target.closest || !e.target.closest('.tyk-quick-filter__pop')) {
      closeAllPopovers(null);
    }
  });

  // Escape closes popovers.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllPopovers(null);
    }
  });

  // "Open full filters" fallback link → deep-link into Dawn's drawer.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('[data-quick-filter-openmain]');
    if (!link) return;
    e.preventDefault();
    closeAllPopovers(null);
    var drawer = document.querySelector('.mobile-facets__disclosure');
    if (drawer && !drawer.hasAttribute('open')) {
      drawer.setAttribute('open', '');
    }
  });

})();

/* ─────────────────────────────────────────────────────────────────────
   In-stock-default opt-out
   The collection grid (sections/tyk-collection-product-grid.liquid) pre-
   applies filter.v.availability=1 on a fresh visit. When the shopper clears
   it — the "In stock" pill ✕ or "Remove all" — remember that choice for this
   collection for the session so the default doesn't immediately re-apply on
   the next full page load. Dawn handles the removal itself (fetch); this only
   records intent for subsequent loads.
   ───────────────────────────────────────────────────────────────────── */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('facet-remove a, a.active-facets__button-remove');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hadAvail = /[?&]filter\.v\.availability=/.test(location.search);
    var keepsAvail = /filter\.v\.availability=/.test(href);
    if (hadAvail && !keepsAvail) {
      try { sessionStorage.setItem('tykCollShowAll:' + location.pathname, '1'); } catch (e2) {}
    }
  }, true);
})();

/* ─────────────────────────────────────────────────────────────────────
   Size facet ordering — Small → Medium → Large → XL → XXL (FIX-20260721-03)
   -----------------------------------------------------------------------
   Shopify serves facet values alphabetically by default (Large before
   Medium). This reorders any facet value list that is PURELY sizes, in both
   the desktop sidebar and the mobile drawer. It re-runs on facet re-render
   (Dawn swaps the form HTML on every filter change) via a MutationObserver,
   and no-ops once a list is already ordered so it can never loop.
   Only touches lists where EVERY value is a recognised size, so colour/print
   and other facets are left untouched. Mirrors the Case Builder add-on
   picker's sizeRank() (snippets/tyk-box-addon-picker.liquid).
   The cleaner long-term fix is Shopify Admin → Search & Discovery → Filters →
   Size → sort values manually; this handles it theme-side in the meantime.
   ───────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  function sizeRank(label) {
    var s = String(label).toLowerCase();
    if (/xxl|2xl|xx-large/.test(s)) return 5;
    if (/\bxl\b|x-large|extra[\s-]*large/.test(s)) return 4;
    if (/large|\blg\b/.test(s)) return 3;
    if (/medium|\bmed\b|\bmd\b/.test(s)) return 2;
    if (/small|\bsm\b/.test(s)) return 1;
    return 99;
  }

  function reorder() {
    var parents = [];
    document.querySelectorAll('li.facets__item, li.mobile-facets__item').forEach(function (li) {
      var ul = li.parentElement;
      if (ul && parents.indexOf(ul) === -1) parents.push(ul);
    });
    parents.forEach(function (ul) {
      var items = Array.prototype.filter.call(ul.children, function (n) {
        return n.nodeType === 1 &&
          (n.classList.contains('facets__item') || n.classList.contains('mobile-facets__item'));
      });
      if (items.length < 2) return;
      var ranked = items.map(function (li) { return { li: li, r: sizeRank(li.textContent || '') }; });
      // Skip unless the whole list is sizes (leave colour/print facets alone).
      if (ranked.some(function (x) { return x.r === 99; })) return;
      // Already in order? Do nothing — this is what stops the observer looping.
      var ordered = ranked.every(function (x, i) { return i === 0 || ranked[i - 1].r <= x.r; });
      if (ordered) return;
      ranked.sort(function (a, b) { return a.r - b.r; });
      ranked.forEach(function (x) { ul.appendChild(x.li); });
    });
  }

  function run() { try { reorder(); } catch (e) {} }

  function start() {
    run();
    var mo = new MutationObserver(run);
    ['FacetFiltersForm', 'FacetFiltersFormMobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
